import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Image,
	TouchableOpacity,
	Linking,
	Switch,
} from "react-native";
import { NavigationActions } from "react-navigation";
import { translate } from "react-i18next";

import AWS from "aws-sdk/dist/aws-sdk-react-native";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";

import { push, reset } from "utils/navigation";
import { STATES, COUNTRY } from "utils/config";
import { signUp, login } from "utils/awsAuth";
import { TextField } from "components/third-party/Textfield";
import ViewScroll from "components/ViewScroll";
import BackgroundImage from "components/BackgroundImage";
import Text from "components/StyledText";
import validation from "utils/validation";
import Checkbox from "components/Checkbox";
import Header from "components/Header";
import Button from "components/Button";
import Textfield from "components/Textfield";
import Select from "components/Select";

import * as x from "../../../styles/css";

class Register extends Component {
	static navigationOptions = {
		header: null,
	};

	constructor(props) {
		super(props);

		this.state = {
			inputs: {
				email: "",
				name: "",
				mobileNumber: "",
				address: "",
				addressLine2: "",
				suburb: "",
				postcode: "",
				state: "ACT",
				password: "",
				country: "Australia",
				confirmPassword: "",
				dialingCode: "61",
				signupForNews: false,
			},
			error: {
				email: "",
				name: "",
				address: "",
				addressLine2: "",
				mobileNumber: "",
				suburb: "",
				postcode: "",
				state: "",
				password: "",
				confirmPassword: "",
				country: "",
				dialingCode: "",
			},
			loading: false,
		};

		this.goLogin = this.goLogin.bind(this);
		this.register = this.register.bind(this);
		this.dialingCodeExists = this.dialingCodeExists.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.inputs.country !== this.state.inputs.country) {
			this.setState({
				inputs: {
					...this.state.inputs,
					dialingCode: COUNTRY.find(
						item => item.name === this.state.inputs.country
					).dial_code,
					state: "",
				},
			});
		}
	}

	register() {
		const { error } = this.state;
		const { t } = this.props;

		const inputs = {
			...this.state.inputs,
		};

		let errorFound = false;
		const msg = {};
		this.setState({
			loading: true,
		});

		if (!inputs.mobileNumber) {
			inputs.mobileNumber = null;
		}
		let validateInputs = validation(inputs);

		if (validateInputs) {
			Object.keys(validateInputs).forEach(
				x => (validateInputs[x] = validateInputs[x][0])
			);
			Object.keys(validateInputs).map((key, index) => {
				validateInputs[key] = this.props.t(validateInputs[key]);
			});
		}

		if (inputs.password !== inputs.confirmPassword) {
			msg.password = t("validation.passMatch");
			msg.confirmPassword = t("validation.passMatch");
			errorFound = true;
		}

		if (inputs.mobileNumber) {
			inputs.mobileNumber = `+${inputs.dialingCode}${
				inputs.mobileNumber
			}`;
		}

		if (errorFound || validateInputs) {
			console.log(validateInputs);
			return this.setState({
				error: { ...validateInputs, ...msg },
				loading: false,
			});
		}

		const Password = inputs.password;
		const user = {
			name: inputs.name,
			email: inputs.email.toLowerCase(),
			phone_number: inputs.mobileNumber,
			"custom:address_line_one": inputs.address,
			"custom:address_line_two": inputs.addressLine2,
			"custom:suburb": inputs.suburb,
			"custom:postcode": inputs.postcode,
			"custom:state": inputs.state,
			"custom:signupForNews": inputs.signupForNews ? "1" : "0",
			"custom:country": inputs.country,
		};

		var attributeList = [];
		Object.entries(user).forEach(([Name, Value]) =>
			attributeList.push(
				new CognitoUserAttribute({
					Name,
					Value,
				})
			)
		);

		signUp(user.email, Password, attributeList)
			.then(resp => {
				login(user.email, Password)
					.then(result => {
						this.setState({
							loading: false,
						});
						push({ web: "/", mobile: "Home" }, this.props);
					})
					.catch(err => {
						console.log(err);
						this.setState({
							loading: false,
						});
						this.goLogin();
					});
			})
			.catch(err => {
				if (err) {
					if (err.message) {
						console.log(err.message);
						Object.keys(err.message).forEach(key => {
							err.message[key] = t(err.message[key]);
						});

						this.setState({
							error: { ...err.message },
						});
					}
					return;
				} else {
					this.goLogin();
				}
			});

		this.setState({
			loading: false,
		});
	}

	dialingCodeExists(code) {
		return !!COUNTRY.find(item => item.dial_code === code);
	}

	goLogin() {
		reset({ web: "/login", mobile: "Login" }, this.props);
	}

	render() {
		const { inputs, error } = this.state;

		const { t } = this.props;

		const termsLink = (
			<View
				style={[
					Platform.OS === "web"
						? x.flexDirection.row
						: x.flexDirection.column,
				]}
			>
				<Text>{t("userAuth.registration.termsText")}</Text>
				<TouchableOpacity
					onPress={() => {
						Linking.openURL("https://www.coolbreeze.com.au/");
					}}
				>
					<Text style={{ color: x.colors.default }}>
						{t("userAuth.registration.termsAndConditions")}
					</Text>
				</TouchableOpacity>
			</View>
		);

		return (
			<ViewScroll>
				<View style={[x.mb.three]}>
					<Header>{t("userAuth.registration.title")}</Header>
					<Text help style={[x.mb.three]}>
						{t("userAuth.registration.help")}
					</Text>
					<TouchableOpacity onPress={this.goLogin}>
						<Text style={[{ color: x.colors.default }]}>
							{t("userAuth.registration.alreadyHaveAccount")}
						</Text>
					</TouchableOpacity>
				</View>
				<View style={[x.my.three]}>
					<Textfield
						label={t("labels.email")}
						value={inputs.email}
						error={error.email}
						onChangeText={email =>
							this.setState({
								inputs: { ...inputs, email },
							})
						}
						keyboardType="email-address"
					/>
					<Textfield
						label={t("labels.name")}
						value={inputs.name}
						error={error.name}
						onChangeText={name =>
							this.setState({
								inputs: { ...inputs, name },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						label={t("labels.address")}
						value={inputs.address}
						error={error.address}
						onChangeText={address =>
							this.setState({
								inputs: { ...inputs, address },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						value={inputs.addressLine2}
						label={t("labels.addressLine2")}
						error={error.addressLine2}
						onChangeText={addressLine2 =>
							this.setState({
								inputs: { ...inputs, addressLine2 },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						value={inputs.suburb}
						label={t("labels.suburb")}
						error={error.suburb}
						onChangeText={suburb =>
							this.setState({
								inputs: { ...inputs, suburb },
							})
						}
						keyboardType="default"
					/>
					<View style={[x.d.flex]}>
						<Select
							native
							label={t("labels.country")}
							onChange={country =>
								this.setState({
									inputs: {
										...inputs,
										country: country.target.value,
									},
								})
							}
							onChangeText={country =>
								this.setState({
									inputs: {
										...inputs,
										country,
									},
								})
							}
							value={inputs.country}
							error={error.country}
							data={COUNTRY.map(item => item.name)}
						/>
					</View>
					<View
						style={[
							x.flexDirection.row,
							x.justifyContent.flexStart,
						]}
					>
						<View style={{ flex: 1 }}>
							<Textfield
								label={t("labels.postcode")}
								value={inputs.postcode}
								error={error.postcode}
								onChangeText={postcode =>
									this.setState({
										inputs: {
											...inputs,
											postcode,
										},
									})
								}
								keyboardType="numeric"
							/>
						</View>
						<View style={[x.d.flex, styles.state]}>
							{inputs.country &&
							inputs.country.toLowerCase() === "australia" ? (
								<Select
									native
									label={t("labels.state")}
									onChange={state =>
										this.setState({
											inputs: {
												...inputs,
												state: state.target.value,
											},
										})
									}
									onChangeText={state =>
										this.setState({
											inputs: {
												...inputs,
												state,
											},
										})
									}
									value={inputs.state}
									error={error.state}
									data={STATES}
								/>
							) : (
								<Textfield
									label={t("labels.state")}
									value={inputs.state}
									error={error.state}
									onChangeText={state =>
										this.setState({
											inputs: {
												...inputs,
												state,
											},
										})
									}
									keyboardType="default"
								/>
							)}
						</View>
					</View>
					<View style={[x.flexDirection.row]}>
						<View
							style={[
								Platform.OS !== "web" ? x.d.flex : {},
								x.mr.two,
							]}
						>
							<Textfield
								label={t("labels.dialingCode")}
								flag={
									this.dialingCodeExists(inputs.dialingCode)
										? COUNTRY.find(
												item =>
													item.dial_code ===
													inputs.dialingCode
										  ).flag
										: "🚫"
								}
								value={inputs.dialingCode}
								error={error.dialingCode}
								onChangeText={dialingCode =>
									this.setState({
										inputs: {
											...inputs,
											dialingCode,
										},
									})
								}
								keyboardType="numeric"
							/>
						</View>
						<Textfield
							label={t("labels.mobileNumber")}
							containerStyle={[
								Platform.OS === "web" ? x.d.flex : x.d.flex3,
							]}
							value={inputs.mobileNumber}
							error={error.mobileNumber}
							onChangeText={mobileNumber =>
								this.setState({
									inputs: { ...inputs, mobileNumber },
								})
							}
							keyboardType="numeric"
						/>
					</View>
					<Textfield
						value={inputs.password}
						label={t("labels.password")}
						secureTextEntry
						autoCapitalize="none"
						error={error.password}
						title="Minimum 6 characters"
						onChangeText={password =>
							this.setState({
								inputs: { ...inputs, password },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						value={inputs.confirmPassword}
						label={t("labels.confirmPassword")}
						secureTextEntry
						autoCapitalize="none"
						error={error.confirmPassword}
						onChangeText={confirmPassword =>
							this.setState({
								inputs: { ...inputs, confirmPassword },
							})
						}
						keyboardType="default"
					/>
					<View style={[x.mb.two]}>
						<Checkbox
							label={t("labels.signUpNews")}
							value={inputs.signupForNews}
							onValueChange={value =>
								this.setState({
									inputs: { ...inputs, signupForNews: value },
								})
							}
						/>
					</View>
				</View>
				<View style={[x.mt.one]}>
					{termsLink}
					<Button
						disabled={this.state.loading}
						onPress={this.register}
						title={t("labels.register")}
						color={x.colors.default}
					/>
				</View>
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	body: {
		backgroundColor: "white",
	},
	appHeader: {
		padding: 20,
		height: 100,
	},
	appTitle: {
		fontSize: 16,
		color: "white",
	},
	appIntro: {
		flex: 2,
		fontSize: 30,
		textAlign: "center",
	},
	loginBody: {
		marginTop: 40,
	},
	scrollView: {
		marginBottom: 20,
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		backgroundColor: "white",
	},
	state: {
		paddingLeft: 20,
	},
	background: {
		backgroundColor: "#fff",
		...(Platform.OS === "web"
			? { maxHeight: 600, minHeight: 500, width: "100%" }
			: {}),
	},
});

export default translate()(Register);



// WEBPACK FOOTER //
// ./src/views/UserAuth/Register/index.js